module.exports = __webpack_public_path__ + "img/Bjornson_Signatur.b8147a5f.jpg";